var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.textDialog, width: "500px" },
      on: {
        input: function($event) {
          return _vm.$emit("closeTextDialog")
        }
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "image-card" },
        [
          _c("v-card-title", { staticClass: "d-flex justify-center" }, [
            _c("h4", [_vm._v(_vm._s(_vm.text))])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6886124e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6886124e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldManagement/FieldWork/Data/TaskType/TextMessage.vue
// module id = null
// module chunks = 